import React, { Fragment } from "react";
import { Link } from "react-router-dom";

// Material-UI
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

// Material-UI icons
import CheckCircle from "@mui/icons-material/CheckCircle";
import Info from "@mui/icons-material/Info";

const BoxInfo = (props) => {
  const { classes, theme, status, text, link } = props;
  const CustomIcon = React.cloneElement(props.icon, {
    className: classes.icon,
  });

  const getContentti = () => {
    return (
      <Stack
        className={classes.gridContainer}
        direction="column"
        spacing={1}
        sx={{
          alignItems: "center",
          justifyContent: "center",
          width: 1,
          height: 1,
        }}
      >
        {CustomIcon}
        <Box className={classes.titleTextContainer} sx={{ width: 1 }}>
          <Typography>{text}</Typography>
        </Box>
      </Stack>
    );
  };

  return (
    <Fragment>
      <Box
        className={classes.boxContainer}
        sx={{
          borderRadius: "24px",
          bgcolor: theme.palette.primary.main,
          borderColor: "text.primary",
          m: 0,
          border: 0,
          width: "100%",
          height: "12rem",
          p: 3,
        }}
      >
        {status ? (
          <div className={classes.statusContainer}>
            {status == 1 ? <CheckCircle className={classes.statusOk} /> : null}

            {status == 2 ? <Info className={classes.statusWarning} /> : null}
          </div>
        ) : null}

        {link ? (
          <Fragment>
            <Link to={link} style={{ textDecoration: "none" }}>
              {getContentti()}
            </Link>
          </Fragment>
        ) : (
          <Fragment>{getContentti()}</Fragment>
        )}
      </Box>
    </Fragment>
  );
};

export default BoxInfo;
